import { ErrorBoundaryBase, type ErrorBoundaryBaseProps } from "@core/ui";

export type Props = Omit<ErrorBoundaryBaseProps, "data-testid">;

/**
 * Styled error boundary component wrapping ErrorBoundaryBase.
 * Catches JavaScript errors in child components and renders a fallback UI.
 */
export function ErrorBoundary({ children, fallback, resetKey, onError }: Props) {
  return (
    <ErrorBoundaryBase
      fallback={fallback}
      resetKey={resetKey}
      onError={(error, errorInfo) => {
        console.error("ErrorBoundary caught:", error);
        onError?.(error, errorInfo);
      }}
      data-testid="error-boundary"
    >
      {children}
    </ErrorBoundaryBase>
  );
}

export default ErrorBoundary;

